import { render } from "./AppSearchInput.vue?vue&type=template&id=2f35df30&ts=true"
import script from "./AppSearchInput.vue?vue&type=script&lang=ts"
export * from "./AppSearchInput.vue?vue&type=script&lang=ts"

import "./AppSearchInput.vue?vue&type=style&index=0&id=2f35df30&lang=scss"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__